"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgb = exports.rgbToHex = exports.isDark = exports.isLight = void 0;
var tinycolor = require('tinycolor2');
function isLight(color) {
    return tinycolor(color).isLight();
}
exports.isLight = isLight;
function isDark(color) {
    return tinycolor(color).isDark();
}
exports.isDark = isDark;
function rgbToHex(color) {
    var colorObject = tinycolor(color);
    if (colorObject.getFormat() !== 'rgb') {
        console.warn("Wrong argument in rgbToHex(). Expected format: rgb, received: " + colorObject.getFormat());
    }
    return colorObject.toHexString();
}
exports.rgbToHex = rgbToHex;
function hexToRgb(color) {
    var colorObject = tinycolor(color);
    if (colorObject.getFormat() !== 'hex') {
        console.warn("Wrong argument in hexToRgb(). Expected format: hex, received: " + colorObject.getFormat());
    }
    return colorObject.toRgbString();
}
exports.hexToRgb = hexToRgb;
//# sourceMappingURL=color-utils.js.map